import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/student-level-section/StudentAssignmentAction";
import * as uiHelpers from "../StudentLevelSectionUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage,
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useStudentLevelSectionUIContext } from "../StudentLevelSectionUIContext";

export function StudentLevelSectionTable({
  removeStudents
}) {
  // Student Level Section UI Context
  const studentLevelSectionUIContext = useStudentLevelSectionUIContext();
  const studentLevelSectionUIProps = useMemo(() => {
    return {
      ids: studentLevelSectionUIContext.ids,
      setIds: studentLevelSectionUIContext.setIds,
      queryParams: studentLevelSectionUIContext.queryParams,
      setQueryParams: studentLevelSectionUIContext.setQueryParams
    };
  }, [studentLevelSectionUIContext]);

  // Getting curret state of Student Level Section list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentLevelSection }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isDeletionAuthorized } = getAuthorities(authorities);
  
  // Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    studentLevelSectionUIProps.setIds([]);
    dispatch(actions.getStudentAndLevelSections(studentLevelSectionUIProps.queryParams));
    return () => dispatch(actions.cleanStudentLevelSectionState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentLevelSectionUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "grade",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "sexName",
      text: "Cinsiyeti",
      sort: true,
      sortCaret: sortCaret,
    },    
    {
      dataField: "levelSection",
      text: "Kur Sınıfı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "levelCourse",
      text: "Kur Dersi",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isDeletionAuthorized,
      removeStudents
    },
    classes: "text-center",
    headerClasses: "text-center",
    style: {
      width: "90px",
    }
  }

  if (isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: studentLevelSectionUIProps.queryParams.pageSize,
    page: studentLevelSectionUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                studentLevelSectionUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: studentLevelSectionUIProps.ids,
                setIds: studentLevelSectionUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}